export default "__VITE_PUBLIC_ASSET__4df48af2__"